// RECOMMEND A SOURCE — option sets for the submission flow.
import { LIFE_CATEGORIES } from "@/lib/lifeCategories";

export const REC_TYPES = [
  "A WEBSITE", "A STORE", "A MARKETPLACE", "A SERVICE", "A DEAL", "A DISCOUNT",
  "A FREE RESOURCE", "A GOVERNMENT PROGRAM", "A COMMUNITY RESOURCE",
  "A SECONDHAND SOURCE", "A RENTAL SERVICE", "A BORROWING / SHARING OPTION",
  "A REBATE", "A REFUND / SETTLEMENT", "A LOCAL RESOURCE", "SOMETHING ELSE",
];

export const REC_CATEGORIES = [...LIFE_CATEGORIES.map((c) => c.name), "I'M NOT SURE"];

export const AVAILABILITY = [
  "EVERYWHERE / ONLINE", "U.S.", "SPECIFIC STATES", "SPECIFIC CITIES", "MY LOCAL AREA", "OTHER",
];

export const LOCATION_SPECIFIC = ["SPECIFIC STATES", "SPECIFIC CITIES", "MY LOCAL AREA", "OTHER"];

export const HOW_FOUND = [
  "I USE IT", "I FOUND IT ONLINE", "A FRIEND TOLD ME", "SOCIAL MEDIA", "I WORK THERE", "OTHER",
];
